import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { GeneralHelper } from '../helpers/general.helper';

@Injectable({
  providedIn: 'root'
})
export class MyOrdersRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    private generalHelper: GeneralHelper
  ) { }

  public getOrders(doc: string, email: string, tokenRecaptcha: string | null, params?: any): Observable<any> {
    let headers = new HttpHeaders();

    if(tokenRecaptcha){
      headers = headers.set('token-recaptcha', tokenRecaptcha);
    }else{
      headers = headers.set('nono-captcha', 'true');
    }
    let query = this.generalHelper.buildQuery(params);
    return this.httpClient.get<any>(`${this.apiUrl}/customer/tickets/${doc}/${email}?${query}`, {headers: headers});
  }

  public cancel(orderId: string): Observable<any> {
    return this.httpClient.delete(`${this.apiUrl}/order/cancel/${orderId}`);
  }

  public getOrderById(id: string): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}/order?forPaymentChange=false&id[]=`+id);
  }

  public getOrderByRfr(ids: any[] = [], forPaymentChange: boolean = false): Observable<any> {
    let query = this.generalHelper.buildQuery({id: ids, forPaymentChange: forPaymentChange});
    return this.httpClient.get<any>(`${this.apiUrl}/order?${query}`);
  }

  public async changeOrderTicketTicketId(orderId: string, cpf: string): Promise<any> {
    return await this.httpClient.get<any>(`${this.apiUrl}/change-order-ticket/${orderId}?cpf=${cpf}`).toPromise();
  }

  public newMapReserve(data: any): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}/order/map/reserve`, data);
  }

  public transferTicket(customer: any, ticketId: string, cpf: string): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}/voucher/transfer/${ticketId}?cpf=${cpf}`, customer);
  }

}
